// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"1652822e","174":"be47f974","223":"b605a263","351":"b201e0ba","466":"f5778879","544":"5d113baa"}[chunkId] + ".chunk.css";
};